import { useState } from "react";

const extractPostID = (input = "") => {
  const results = [];
  // Match base64 segment between .com/ and _
  const regex = /\.com\/([^_\s]+)_/g;
  let match;
  while ((match = regex.exec(input)) !== null) {
    try {
      const decoded = atob(match[1]);
      if (decoded) results.push(decoded);
    } catch {
      // skip invalid base64
    }
  }
  return Array.from(new Set(results));
};

function PostIDViewer() {
  const [query, setQuery] = useState("");
  const [postIDs, setPostIDs] = useState([]);
  const [copiedIdx, setCopiedIdx] = useState(null);

  const handleExtract = () => {
    const ids = extractPostID(query);
    setPostIDs(ids);
  };

  const handleCopy = (id, idx) => {
    navigator.clipboard.writeText(id).then(() => {
      setCopiedIdx(idx);
      setTimeout(() => setCopiedIdx(null), 1500);
    });
  };

  return (
    <div className="p-6 space-y-4 bg-white">
      <div>
        <label className="block text-sm font-medium mb-2">
          Paste URL(s) to extract Post ID
        </label>
        <textarea
          rows={3}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="e.g. https://way2newsapp.com/MTk1Nzg4OTU=_lng1/83"
          className="w-full rounded-md border border-gray-300 p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          style={{ minHeight: "80px" }}
        />
        <div className="mt-3 flex justify-end">
          <button
            type="button"
            onClick={handleExtract}
            className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Extract Post ID
          </button>
        </div>
      </div>

      {postIDs.length > 0 && (
        <div className="space-y-2">
          {postIDs.map((id, idx) => (
            <div
              key={idx}
              className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 px-4 py-3"
            >
              <span className="text-sm font-mono text-gray-800">{id}</span>
              <button
                type="button"
                onClick={() => handleCopy(id, idx)}
                className="ml-4 text-gray-500 hover:text-blue-600 transition-colors"
                title="Copy"
              >
                {copiedIdx === idx ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                    <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
                  </svg>
                )}
              </button>
            </div>
          ))}
        </div>
      )}

      {postIDs.length === 0 && query.trim() && (
        <p className="text-sm text-gray-500">No valid Post IDs found in the input.</p>
      )}
    </div>
  );
}

export default PostIDViewer;
